import moment from 'moment';
import React, { Component, Fragment } from 'react';
import { get } from '../../../server/actions';
import { showFile, _addNotificationError } from '../../../server/util';
import { getLoginDistrictInfo } from '../../../server/utilDistrict';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './customReactDatepicker.css'
import TmExportExcel from '../../Misc/tmExportExcel/tmExportExcel';
import './reports.css';
import onlineDepositReportIcon from './../../../assets/img/mm/icon-8.png';
class OnlineDepositReport extends Component {
    constructor(props){
        super(props);
        this.state={
            startDate: props.reportDefaultDate || new Date(),
            endDate: props.reportDefaultDate || new Date(),
            onlineDepositReport:[],
            userInfo: getLoginDistrictInfo(),
        }
    }
    componentWillMount=()=>{
         this.getOnlineDepositReport();
     }
     componentWillReceiveProps=(nextProps)=>{
        if(nextProps.selectSchool!=this.props.selectSchool){
            this.getOnlineDepositReport();
        }        
    } 
     getOnlineDepositReport=()=>{
        const districtID = this.state.userInfo.districtId;
        let schoolID = parseInt(this.props.selectSchool);
        const s_d_id=schoolID>0?schoolID:districtID;
        const isSchool=schoolID>0?true:false;
        const schoolYear = this.props.selectedSchoolYear || this.state.userInfo.schools[0].activeSchoolYear;
        let start = moment(this.state.startDate).format('YYYY-MM-DD')+"T00:00:00";
        let end = moment(this.state.endDate).format('YYYY-MM-DD')+"T23:59:59";  
        const _url='/reports/onlinePaymetReport?districtId='+s_d_id+'&isSchoolId='+isSchool+'&isFileData=true'+ '&startDate=' + this.getSystemDateTime(start)+ '&endDate=' + this.getSystemDateTime(end) +'&schoolYear='+schoolYear+'&access_token=';
        get(_url).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            const resData=(data.transactionReportsDetails||[])
            this.setState({ onlineDepositReport: resData, loading:false})
        }).catch(error => {
            this.setState({ onlineDepositReport: [], loading:false})
            console.log("Loading Report Failed", error)
        });
    }
    getSystemDateTime = (date) =>{        
        let _datetime=moment(date,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss")
        return _datetime;
    }
     bindData=()=>{
         const districtID = this.state.userInfo.districtId;
         let schoolID = parseInt(this.props.selectSchool);
         const s_d_id=schoolID>0?schoolID:districtID;
         const isSchool=schoolID>0?true:false;
         const schoolYear = this.props.selectedSchoolYear || this.state.userInfo.schools[0].activeSchoolYear;
         let start = moment(this.state.startDate).format('YYYY-MM-DD')+"T00:00:00";
         let end = moment(this.state.endDate).format('YYYY-MM-DD')+"T23:59:59";
         let _url='';
        if(schoolID>0){
            _url='/reports/onlinePaymetReport?districtId='+schoolID+'&isSchoolId=true&isFileData=false'
            + '&startDate=' + moment(start,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&endDate=' + moment(end,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") +
             '&schoolYear='+schoolYear+'&access_token=';
        }else{
            _url='/reports/onlinePaymetReport?districtId='+districtID+'&isFileData=false'
            + '&startDate=' + moment(start,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&endDate=' + moment(end,'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") +
             '&schoolYear='+schoolYear+'&access_token=';
        }
         this.setState({loading: true})
         get(_url).then((response) => {
             if (!response.ok) {
                 if(response.status===417|| response.status===422){
                     return response.json();
                 }
             }
             console.log('response', response);
             return response;
         }).then(res => {
             if(res.statusCode===417){
                 _addNotificationError(res.statusMessage,this.props)
                     throw Error(res.errorMessage);
                 }else if(res.statusCode===422){
                     throw Error(res.statusMessage);
                 }else{
                     return res.blob();                
                 } 
         }).then(blob => {
             let filename = "OnlineDepositReport";
             showFile(blob,filename);            
                 this.setState({loading: false})
             }).catch((error) => {
                 let msg=''
                 if(typeof error==='string'){
                     msg=error;
                 }else{
                     msg=error.message;
                 }
                 _addNotificationError(msg,this.props);
                 this.setState({loading: false})
             }
         );
     }
     buildOnlineDepDataFormatForExport=()=>{
        const colsObj={
            "schoolName":"Site",
            "studentLName":"Student Last Name",
            "studentFName":"Student First Name",
            "transactionDate":"Transaction Date",
            "transactionTime":"Transaction Time",
            "amount":"Amount",
            "note":"Note",
            "paymentType":"Payment Type",
            "type":"Type",
            "checkNum":"Check / CC TX. No. / TX. ID"
        };
        return (
            [{
              columns: Object.values(colsObj||{}),
              data: this.state.onlineDepositReport.map(item => {
                  return Object.keys(colsObj).map(key=>{
                      return item[key]||''
                  })
              })
            }]
        );
    }
    render() {
        const {startDate, endDate}=this.state;
        return (
            <Fragment>
                <div className="reportCard reportCard-margin">
                <div className="reportCard-body">
                    <div className="reportCard-widget">
                        <div className="reportCard-widget-title-wrapper">
                            <div className="reportCard-widget-date-primary"> 
                            <img src={onlineDepositReportIcon} />                                                    
                            </div>
                            <div className="reportCard-widget-meeting-info">
                                <span className="reportCard-widget-pro-title color-3"><b>Online Deposits Report</b></span>                                                    
                            </div>
                        </div>                                            
                    <div className="reportCard-widget-meeting-points">
                        <div className="row form-group">
                            <label class="col-sm-12 control-label">Start Date</label>
                            <div className="col-sm-12 ">
                                <DatePicker wrapperClassName="fullWidthDatepicker"                               
                                    selected={startDate}
                                    onChange={(date) => {
                                        this.setState({startDate:date},()=>{
                                            this.getOnlineDepositReport()
                                        });
                                    }} className='form-control form-control-sm' />
                            </div>
                        </div>
                        <div className="row form-group">
                            <label class="col-sm-12 control-label">End Date</label>
                            <div className="col-sm-12 ">
                                <DatePicker   wrapperClassName="fullWidthDatepicker"                             
                                    selected={endDate}
                                    onChange={(date) => {
                                        this.setState({endDate:date},()=>{
                                            this.getOnlineDepositReport()
                                        });
                                    }} className='form-control form-control-sm' />
                            </div>
                        </div>
                    </div>
                    <div className='reportCard-widget-meeting-action'>
                            <div className="form-group">
                            <button type='button' className='btn btn-sm btn-success' style={{margin:'0px 5px 0px 0px'}} onClick={()=>{
                                this.bindData()
                            }}>
                                Download Report
                            </button>
                        <TmExportExcel
                                id={"onlineDepositReport"} 
                                name={"Online Deposit Report"}
                                filename={"Online Deposit Report"}
                                element={<button type='button' id={"onlineDepositReport"} className="btn btn-warning btn-sm" style={{margin:'0px 5px 0px 0px'}}><i className="fa fa-file-excel-o"></i> Export</button>}
                                dataSet={this.buildOnlineDepDataFormatForExport()}
                                />
                            
                        </div>
                        </div>
                    </div>             
            </div>
            </div>
            </Fragment>
        );
    }
}

export default OnlineDepositReport;


// WEBPACK FOOTER //
// ./src/components/District/Reports/onlineDepositReport.js